import joinComponents from './joinComponents';

export default joinComponents;
